import { CustomModal, FormEntry } from "components";
import { addCourseConfidenceModalReducerActions } from "./reducer";
import { useAddCourseConfidenceForm, useMutateCourseConfidence } from "./form";
import { useEffect, useMemo } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Button } from "reactstrap";
import { useCourseQuery } from "./queries";

const EditCourseConfidenceModal = ({ courseConfidenceModalState, courseConfidenceModalDispatch }) => {
	const { data } = useCourseQuery();

	const {
		register,
		handleSubmit,
		setValue,
		control,
		formState: { errors },
		watch,
	} = useAddCourseConfidenceForm();
	const selectedCourseId = watch("courseId");

	const { mutate: addCourseConfidence } = useMutateCourseConfidence({
		type: "edit",
		courseId: courseConfidenceModalState.data?.id,
		onSuccess: () => courseConfidenceModalDispatch({ type: addCourseConfidenceModalReducerActions.HIDE }),
	});

	const courseOptions = useMemo(() => data?.map((course) => ({ label: course.name, value: course.id })) || [], [data]);

	const lessonOptions = useMemo(() => {
		return selectedCourseId === undefined || data === undefined
			? []
			: data
					?.find((course) => course.id === selectedCourseId)
					.lessons.filter((lesson) => !lesson.isCustomLesson)
					.map((lesson) => ({ label: lesson.name, value: lesson.id }));
	}, [selectedCourseId]);

	useEffect(() => {
		setValue("courseId", courseConfidenceModalState.data?.courseId);
		setValue("confidenceLevel", courseConfidenceModalState.data?.confidenceLevel);
		setValue("lessonId", courseConfidenceModalState.data?.lessonId);
		console.log(courseConfidenceModalState.data?.lessonId);
	}, [courseConfidenceModalState.data]);

	return (
		<CustomModal
			show={courseConfidenceModalState.show}
			compact={true}
			hideModal={() => courseConfidenceModalDispatch({ type: addCourseConfidenceModalReducerActions.HIDE })}
			title="Course Confidence Entries"
		>
			<form onSubmit={handleSubmit((data) => addCourseConfidence(data))} className="mt-4">
				<div className="mb-3">
					<Controller
						control={control}
						name="courseId"
						render={({ field: { value, onChange } }) => (
							<Select
								className="react-select info w-100"
								classNamePrefix="react-select"
								name="singleSelect"
								value={courseOptions.find((course) => course.value === value)}
								onChange={(selectedCourse) => {
									onChange(selectedCourse.value);
								}}
								options={courseOptions}
								placeholder="Select Course"
							/>
						)}
					/>
				</div>
				<div className="mb-3">
					<Controller
						control={control}
						name="lessonId"
						render={({ field: { value, onChange } }) => (
							<Select
								className="react-select info w-100"
								classNamePrefix="react-select"
								name="singleSelect"
								value={lessonOptions.find((course) => course.value === value)}
								onChange={(selectedLesson) => {
									onChange(selectedLesson.value);
								}}
								options={lessonOptions}
								placeholder="Select Lesson"
								isDisabled={!lessonOptions?.length}
							/>
						)}
					/>
				</div>
				<div className="mt-3">
					<FormEntry
						register={register}
						name="confidenceLevel"
						type="number"
						formLabel="Confidence Level"
						step={10}
						required
						error={errors.confidenceLevel}
					/>
				</div>

				<div className="d-flex justify-content-end">
					<Button type="submit" color="success">
						Save
					</Button>
				</div>
			</form>
		</CustomModal>
	);
};

export default EditCourseConfidenceModal;
